var _path, _path2, _rect, _rect2, _rect3, _path3, _path4, _path5, _path6, _path7, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path8, _path9, _path10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDockviewSplash2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 312,
    height: 200,
    fill: "none",
    viewBox: "0 0 312 200",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCDC",
    d: "M0 5a5 5 0 0 1 5-5h302a5 5 0 0 1 5 5v6H0V5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M0 10h312v1H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 4,
    y: 3,
    fill: "#FD605E",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 10,
    y: 3,
    fill: "#FBBC3F",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 16,
    y: 3,
    fill: "#34C942",
    rx: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 11h312v189H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000C18",
    d: "M0 11h166v189H0zM167 11h145v189H167z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B4A",
    d: "M166 11h1v189h-1zM167 56h145v1H167zM167 112h145v1H167z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C2A",
    d: "M0 11h166v10H0zM0 22h166v10H0zM0 94h166v10H0zM0 190h166v10H0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B4A",
    d: "M0 21h166v1H0z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 4,
    x: 11,
    y: 14,
    fill: "#fff",
    rx: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 4,
    x: 34,
    y: 14,
    fill: "#fff",
    rx: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 4,
    x: 11,
    y: 25,
    fill: "#fff",
    rx: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 4,
    x: 19,
    y: 25,
    fill: "#fff",
    rx: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 4,
    x: 11,
    y: 97,
    fill: "#fff",
    rx: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 4,
    x: 29,
    y: 97,
    fill: "#fff",
    rx: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 4,
    x: 11,
    y: 193,
    fill: "#fff",
    rx: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m5 29-3-3.392.538-.608L5 27.799l2.463-2.785.537.608L5 29ZM5 101l-3-3.392.538-.608L5 99.799l2.463-2.785.537.608L5 101ZM6 16l-3.392 3L2 18.462 4.799 16l-2.785-2.463.608-.537L6 16ZM6 195l-3.392 3-.608-.537L4.799 195l-2.785-2.462.608-.538L6 195Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M212.674 111c.236 0 .394-.221.297-.416l-2.174-4.409c-.115-.233-.479-.233-.594 0l-2.174 4.409c-.097.195.061.416.297.416h.889a.327.327 0 0 0 .297-.175l.691-1.401c.115-.233.479-.233.594 0l.691 1.401a.327.327 0 0 0 .297.175h.889ZM208.326 114c-.236 0-.394.221-.297.416l2.174 4.409c.115.233.479.233.594 0l2.174-4.409c.097-.195-.061-.416-.297-.416h-.889a.327.327 0 0 0-.297.175l-.691 1.401c-.115.233-.479.233-.594 0l-.691-1.401a.327.327 0 0 0-.297-.175h-.889Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M210.5 116v-7"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19,
    x: 175,
    y: 18,
    fill: "#777",
    rx: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 198,
    y: 18,
    fill: "#777",
    rx: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 5,
    x: 206,
    y: 18,
    fill: "#777",
    rx: 2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 5,
    x: 203,
    y: 71,
    fill: "#777",
    rx: 2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 14,
    x: 228,
    y: 78,
    fill: "#777",
    rx: 2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 5,
    x: 250,
    y: 71,
    fill: "#777",
    rx: 2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 5,
    x: 239,
    y: 95,
    fill: "#777",
    rx: 2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 5,
    x: 272,
    y: 117,
    fill: "#777",
    rx: 2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 5,
    x: 259,
    y: 117,
    fill: "#777",
    rx: 2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 5,
    x: 213,
    y: 95,
    fill: "#777",
    rx: 2
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 5,
    x: 203,
    y: 95,
    fill: "#777",
    rx: 2
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 5,
    x: 198,
    y: 25,
    fill: "#777",
    rx: 2
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 5,
    x: 215,
    y: 25,
    fill: "#777",
    rx: 2
  })));
};
export default SvgDockviewSplash2;